// 自定义指令函数
import { getOriginMenuKeyToValue } from '@/utils/getPermissibleMenu';
import { flatData } from '@/utils/api';

export default {
  bind(el, domVal) {
    // 获取当前页面路由路径
    const path = window.location.pathname;
    let btnPermission;
    let keyBlone;
    if (Array.isArray(domVal.value)) {
      btnPermission = domVal.value[0];
      keyBlone = domVal.value[1];
    } else {
      btnPermission = domVal.value;
    }
    const menus = getOriginMenuKeyToValue().menus;
    const flated = flatData(menus);
    // 获取对应路由权限
    const routeName = flated.filter((item) => {
      return item.code === path;
    });
    // 获取对应页面按钮权限
    const getFunctionCode = (data) => {
      let result = [];
      data.forEach((item) => {
        if (item.type === 'FUNCTION') {
          result.push(item);
        } else if (item.childModuleList) {
          result = [...result, ...getFunctionCode(item.childModuleList)];
        }
      });
      return result;
    };
    const btnPer = getFunctionCode(
      (routeName[0].childModuleList && routeName[0].childModuleList.length) > 0 ? routeName[0].childModuleList : []
    );
    // 改成判断code全称，而不截取
    const systemPower = btnPer.length > 0 ? btnPer.map((item) => item.code) : [];
    let flag = 0;
    // 1,包含数组里面的所有值
    if (Array.isArray(btnPermission) && keyBlone === '&') {
      const arr_set = btnPermission.filter((val) => {
        return systemPower.indexOf(val) > -1;
      });
      if (arr_set.length === btnPermission.length) {
        flag += 1;
      }
    }
    // 2,包含数组里面的某一些值
    if (Array.isArray(btnPermission) && keyBlone === '|') {
      const arr_set = btnPermission.filter((val) => {
        return systemPower.indexOf(val) > -1;
      });
      if (arr_set.length >= 1) {
        flag += 1;
      }
    }
    // 3,直接传标识字符串
    if (!Array.isArray(btnPermission)) {
      systemPower.map((item0) => {
        if (btnPermission == item0) {
          flag += 1;
        }
      });
    }
    if (flag == 0) {
      // 当前按钮没有权限
      el.classList.add('no-permission');
    } else {
      // 当前按钮有权限
      el.classList.remove('no-permission');
    }
  }
};
